import { Button } from '$components'
import { useUpdateCoatTypeForm } from './index'

export function UpdateCoatTypeFormControls() {
  const { onCancel, isLoading } = useUpdateCoatTypeForm()

  return (
    <div className="flex gap-4 mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Button
        isLoading={isLoading}
        type="submit"
        size="lg"
      >
        Save Changes
      </Button>
    </div>
  )
}
